import { mike } from "../../../assets";

export const photoFilenames = [
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136247/ai-event/DSC08593_mtcnct.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136235/ai-event/DSC08605_coe7dh.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136234/ai-event/DSC08617_ztvdvc.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136234/ai-event/DSC08612_pxqdqd.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136232/ai-event/DSC08613_mxluf4.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136224/ai-event/DSC08610_woxh6a.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136219/ai-event/DSC08607_khagwh.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136218/ai-event/DSC08608_niasgp.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136210/ai-event/DSC08603_hsjazi.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136207/ai-event/DSC08597_oeegtw.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136203/ai-event/DSC08587_pjijwi.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136203/ai-event/DSC08599_uqqfnc.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136193/ai-event/DSC08591_kalf2v.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136192/ai-event/DSC08594_mkhzhc.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136191/ai-event/DSC08585_yvzjvf.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136180/ai-event/DSC08590_dp4shp.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136178/ai-event/DSC08583_fkbueg.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136175/ai-event/DSC08568_sjqq01.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136140/ai-event/DSC08566_mj3xv7.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136149/ai-event/DSC08573_mz8khy.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136150/ai-event/DSC08575_m2m7s8.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136161/ai-event/DSC08581_n09frc.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136164/ai-event/DSC08580_d6cizz.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136170/ai-event/DSC08567_wsw7cn.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136172/ai-event/DSC08578_asbgyy.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136117/ai-event/DSC08559_bkd2d7.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136120/ai-event/DSC08554_ev2hwh.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136124/ai-event/DSC08562_l7csis.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136127/ai-event/DSC08546_xcmf0n.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136131/ai-event/DSC08561_yk6cyo.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136140/ai-event/DSC08571_fh5ebq.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136097/ai-event/DSC08544_iub0cj.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136099/ai-event/DSC08547_i0w6je.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136108/ai-event/DSC08552_p5vjgp.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136111/ai-event/DSC08555_hllzr4.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136116/ai-event/DSC08558_f52wa0.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136058/ai-event/DSC08522_b8oake.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136066/ai-event/DSC08524_bkxpdh.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136068/ai-event/DSC08517_rclmeb.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136068/ai-event/DSC08529_h1t6xo.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136073/ai-event/DSC08520_xxrcvb.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136073/ai-event/DSC08520_xxrcvb.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136078/ai-event/DSC08535_ij8sag.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136078/ai-event/DSC08528_hkew72.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136084/ai-event/DSC08537_nqrrnt.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136087/ai-event/DSC08530_gvl7u3.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135985/ai-event/DSC08481_pfgrv8.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135986/ai-event/DSC08473_jl9hy8.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135987/ai-event/DSC08479_yeedkw.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135996/ai-event/DSC08475_cuzvwz.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136002/ai-event/DSC08489_sgsec0.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136002/ai-event/DSC08483_xoxpnz.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136006/ai-event/DSC08491_qvf3km.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136008/ai-event/DSC08493_yxxwcz.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136017/ai-event/DSC08504_guolfx.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136026/ai-event/DSC08496_yvnmpi.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136032/ai-event/DSC08499_er8lru.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136041/ai-event/DSC08508_kiaont.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136053/ai-event/DSC08505_fz0pve.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135929/ai-event/DSC08648_fxh0l9.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135939/ai-event/DSC08442_vlmo2q.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135940/ai-event/DSC08450_dkaiwj.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135948/ai-event/DSC08452_rl3l55.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135950/ai-event/DSC08454_j1itiw.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135954/ai-event/DSC08444_k4hapb.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135955/ai-event/DSC08457_grnkv6.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135961/ai-event/DSC08449_hrb38e.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135963/ai-event/DSC08461_l0j2tr.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135969/ai-event/DSC08455_wdyisp.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135973/ai-event/DSC08460_sf1nj5.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135975/ai-event/DSC08470_d4m6c4.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135976/ai-event/DSC08465_cinhe0.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135977/ai-event/DSC08469_myeeis.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135984/ai-event/DSC08477_m98cud.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135861/ai-event/DSC08634_rjo3na.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135861/ai-event/DSC08637_onetbs.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135873/ai-event/DSC08639_uj6fkn.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135874/ai-event/DSC08644_wci45y.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135878/ai-event/DSC08646_egrbqq.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135923/ai-event/DSC08636_yjnvfw.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746134355/ai-event/DSC08410_o1vsr9.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746134376/ai-event/DSC08409_cljav9.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746134435/ai-event/DSC08408_vwxbes.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746134580/ai-event/DSC08414_klva5x.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746134585/ai-event/DSC08418_os5lrt.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746134659/ai-event/DSC08434_nuetue.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135827/ai-event/DSC08416_ih00mg.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135829/ai-event/DSC08437_okjs15.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135834/ai-event/DSC08621_kmvw8o.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135842/ai-event/DSC08624_wzmfe6.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135844/ai-event/DSC08619_dg2vek.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135850/ai-event/DSC08629_fyo9bf.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135851/ai-event/DSC08435_meqhip.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135853/ai-event/DSC08630_hz5onk.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135859/ai-event/DSC08632_tqbgqc.jpg",
  "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135853/ai-event/DSC08622_c1h4ei.jpg",
];

export const speakers = [
  {
    name: "David Edoja",
    role: "Founder CEO",
    company: "[AI] Analytics Intelligence",
    imageUrl:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1742727529/_MG_0081_1_grd1ga.png",
  },
  {
    name: "Charlie Kellaway",
    role: "Business Development Manager",
    company: "London Stock Exchange",
    imageUrl:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1742727529/thumbnail_image001_1_fodfr0.png",
  },
  {
    name: "Khal Haris",
    role: "Principle CDP strategist, Tealium EMEA",
    company: "Tealium",
    imageUrl:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136068/ai-event/DSC08529_h1t6xo.jpg",
  },
  {
    name: "Mike Fong",
    role: "Senior Solution Engineer",
    company: "ObservePoint",
    imageUrl: mike,
  },
];

export const whyAttendItems = [
  {
    title: "See AI in Action",
    description:
      "Explore how [AI]'s technology is transforming analytics through AI-driven data orchestration and automation.",
  },
  {
    title: "Customer Success Stories",
    description:
      "Hear directly from enterprises leveraging our platform to build and deploy AI applications.",
  },
  {
    title: "Industry Insights",
    description:
      "Gain expert perspectives from our partners and how their solutions are part of the AI data stack optimization.",
  },
  {
    title: "Networking Opportunities",
    description:
      "Connect with like-minded professionals, AI experts, and decision-makers shaping the future of data analytics.",
  },
];

export const whoShouldJoinItems = [
  {
    title: "Business Decision-Makers",
    description:
      "Discover how AI-powered insights can drive better business outcomes.",
  },
  {
    title: "Data & Analytics Leaders",
    description: "Understand how AI is changing enterprise analytics.",
  },
  {
    title: "AI & ML Practitioners",
    description: "Learn how AI-ready data stacks streamline deployment.",
  },
  {
    title: "Technical Teams",
    description:
      "Gain practical insights on building AI applications with enterprise data.",
  },
];

export const videoData = [
  {
    id: "video-1",
    url: "https://mydata-uploads.nyc3.cdn.digitaloceanspaces.com/david-conference/Video%2013-05-2025,%2002%2058%2046.mov",
    thumbnailUrl:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135829/ai-event/DSC08437_okjs15.jpg",
    title: "Shift from the Traditional Analytics to A modern AI Data Stack",
    date: "April 16, 2025",
    time: "09:07",
  },
  {
    id: "video-2",
    url: "https://mydata-uploads.nyc3.cdn.digitaloceanspaces.com/david-conference/Video%2024-04-2025,%2022%2034%2032.mov",
    thumbnailUrl:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746136097/ai-event/DSC08544_iub0cj.jpg",
    title:
      "Fireside Chat: Real World Application of Data Analytics and GenAI Tools",
    date: "April 16, 2025",
    time: "09:36",
  },
  {
    id: "video-3",
    url: "https://mydata-uploads.nyc3.cdn.digitaloceanspaces.com/david-conference/Video%2024-04-2025,%2022%2046%2055.mov",
    thumbnailUrl:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1746135987/ai-event/DSC08479_yeedkw.jpg",
    title: "Ai is nothing without Human Intelligence",
    date: "April 16, 2025",
    time: "11:01",
  },
];
